module.exports = __webpack_public_path__ + "static/img/board.0a39b1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/board.png
// module id = 5wBr
// module chunks = 1